import { SHA256, enc } from 'crypto-js';
import { pushDataLayerOnFormComplete, pushDataLayerOnFormError, pushDataLayerOnFormFieldComplete, pushDataLayerOnFormLoaded } from '3-components/Tracker/Tracker';

interface FormBlockTrackingProps {
    formName: string;
}

interface InitFormBlockTrackingProps {
    el: HTMLElement;
    props: FormBlockTrackingProps;
}

const FormBlockTracking = ({ el, props }: InitFormBlockTrackingProps): void => {
    if (!window.dataLayer || !props || !window.$$epiforms) {
        return;
    }

    const formName = props?.formName;

    const $epiform = window.$$epiforms;

    const $el = window.$$epiforms(el);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    $el.find('.EPiServerForms').on('formsNavigationNextStep formsNavigationPrevStep formsSetupCompleted formsReset formsStartSubmitting formsSubmitted formsSubmittedError formsNavigateToStep formsStepValidating', (e: any) => {
        // push dataLayer on form loaded
        if (e?.type === 'formsSetupCompleted') {
            pushDataLayerOnFormLoaded({
                formName,
                formType: 'general',
            });
        }

        // push dataLayer on error after submit
        if (e?.type === 'formsSubmitted' && !e?.isSuccess) {
            const result = e.returnedResult;
            pushDataLayerOnFormError({
                formName,
                formType: 'general',
                errorMessage: result.message,
            });
        }

        // push dataLayer on error before submit
        if (e?.type === 'formsStepValidating' && !e?.isValid) {
            pushDataLayerOnFormError({
                formName,
                formType: 'general',
                errorMessage: 'Form validation unsuccessful',
            });
        }

        // push dataLayer on submitted successfully
        if (e?.type === 'formsSubmitted' && e?.isSuccess) {
            let userEmail = '';
            const inputEmailName = $epiform('input[autocomplete="email"]', e.target).attr('name');

            if (inputEmailName) {
                const data = e.formData;
                userEmail = data.get(inputEmailName);
            }
            // email should be encrypted to sha256 for dataLayer.
            const userId = userEmail ? SHA256(userEmail).toString(enc.Hex) : '';

            pushDataLayerOnFormComplete({
                formName,
                formType: 'general',
                userId,
            });
        }
    });

    $epiform(document).ready(() => {
        // on input (text, number, textarea) value changes
        $el.find('.EPiServerForms .FormTextbox__Input').on('blur', (e: Event) => {
            const input = e.target as HTMLInputElement;
            const label = input.parentNode?.querySelector('.Form__Element__Caption');

            pushDataLayerOnFormFieldComplete({
                formName,
                formType: 'general',
                fieldName: label?.textContent ?? '',
            });
        });

        // to watch dropdown options fields change
        $el.find('.EPiServerForms .FormSelection select').on('change', (e: Event) => {
            const selectField = e.target as HTMLInputElement;
            const label = selectField.parentNode?.querySelector('.Form__Element__Caption');
            const { value } = selectField;

            pushDataLayerOnFormFieldComplete({
                formName,
                formType: 'general',
                fieldName: label?.textContent ?? '',
                value,
            });
        });

        // to watch radio fields change
        $el.find('.EPiServerForms .FormChoice .FormChoice__Input--Radio, .EPiServerForms .FormChoice .FormChoice__Input--Checkbox').on('change', (e: Event) => {
            const radio = e.target as HTMLInputElement;
            const label = radio.parentNode?.parentNode?.querySelector('.Form__Element__Caption');
            const { value } = radio;

            pushDataLayerOnFormFieldComplete({
                formName,
                formType: 'general',
                fieldName: label?.textContent ?? '',
                value,
            });
        });
    });
};

export default FormBlockTracking;
